import React from 'react';
import { omit } from 'ramda';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import useApp from 'reducers/hooks/useApp';

import RealEstateAgentRegistrationForm from 'sharedComponents/RealEstateAgentRegistrationForm';

import { apiErrorsToFormik } from 'utils/errors';
import useStyles from './useStyles';

const RealEstateAgentRegistration = props => {
  const classes = useStyles();
  const { signUp } = useApp();
  const { onFinish } = props;

  const handleSubmit = async (values, { setErrors }) => {
    const attrs = omit('passwordConfirmation', values);
    try {
      await signUp({ ...attrs, userType: 'realEstateAgent' });
      onFinish();
    } catch (error) {
      const errors = apiErrorsToFormik(error);
      setErrors(errors);
    }
  };

  return (
    <Box className={classes.container}>
      <RealEstateAgentRegistrationForm onSubmit={handleSubmit} />
    </Box>
  );
};

RealEstateAgentRegistration.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default RealEstateAgentRegistration;



// WEBPACK FOOTER //
// ./src/components/SignUp/components/RealEstateAgentRegistration/RealEstateAgentRegistration.js